import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    SomethingWentWrongContainer as SourceSomethingWentWrongContainer
} from 'SourceRoute/SomethingWentWrong/SomethingWentWrong.container';
import history from 'Util/History';

import SomethingWentWrong from './SomethingWentWrong.component';
import { FIREBASE_EDPOINT, PAGE_HAS_BEEN_FORCE_REFRESHED, PAGE_LOGGED_ERROR } from './SomethingWentWrong.config';
/** @namespace Bodypwa/Route/SomethingWentWrong/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace Bodypwa/Route/SomethingWentWrong/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    device: state.ConfigReducer.device
});
/** @namespace Bodypwa/Route/SomethingWentWrong/Container */
export class SomethingWentWrongContainer extends SourceSomethingWentWrongContainer {
    componentDidMount() {
        const { updateMeta } = this.props;
        updateMeta({ title: __('Something went wrong!') });
        this.retryPageLoading();
    }

    state = {
        renderPage: false
    };

    // TODO move in util
    detectBrowser() {
        const ua = navigator.userAgent;
        let tem;
        let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE', version: (tem[1] || '') };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {
                return { name: tem.slice(1).join(' ').replace('OPR', 'Opera'), version: tem[2] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        // eslint-disable-next-line no-cond-assign
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }

        return {
            name: M[0],
            version: M[1]
        };
    }

    retryPageLoading = () => {
        const pageHasAlreadyBeenForceRefreshed = JSON.parse(
            window.localStorage.getItem(PAGE_HAS_BEEN_FORCE_REFRESHED) || 'false'
        );

        if (!pageHasAlreadyBeenForceRefreshed && process.env.NODE_ENV === 'production') {
            window.localStorage.setItem(PAGE_HAS_BEEN_FORCE_REFRESHED, 'true');
            this.logError({ refresh: true, logToLocalStorage: true });
            window.location.reload();
        } else {
            window.localStorage.setItem(PAGE_HAS_BEEN_FORCE_REFRESHED, 'false');
            this.logError({ refresh: false });
            this.setState({ renderPage: true });
        }
    };

    logError(errorData = {}) {
        const { refresh, logToLocalStorage } = errorData;
        const { errorDetails, device } = this.props;
        const {
            location: {
                pathname,
                search: parameters
            } = {}
        } = history;
        const currentDate = new Date(Date.now()).toString();
        const size = {
            winWidth: `${window.innerWidth}px`,
            winHeight: `${window.innerHeight}px`
        };

        const data = {
            pathname,
            parameters,
            currentDate,
            errorDetails,
            baseUrl: window.location.origin,
            windowSession: sessionStorage.getItem('WINDOW_ID'),
            size,
            refresh,
            browser: this.detectBrowser(),
            device
        };

        if (logToLocalStorage) {
            window.localStorage.setItem(PAGE_LOGGED_ERROR, JSON.stringify(data));
        } else {
            fetch(FIREBASE_EDPOINT, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                refresh
            })
                .then(
                /** @namespace Bodypwa/Route/SomethingWentWrong/Container/SomethingWentWrongContainer/logError/then/catch/then/then/fetch/then */
                    (response) => response.json()
                )
                .then(
                /** @namespace Bodypwa/Route/SomethingWentWrong/Container/SomethingWentWrongContainer/logError/then/catch/then/then */
                    (data) => {
                        console.log('Success:', data);
                    }
                )
                .catch(
                /** @namespace Bodypwa/Route/SomethingWentWrong/Container/SomethingWentWrongContainer/logError/then/catch */
                    (error) => {
                        console.error('Error:', error);
                    }
                );
        }
    }

    render() {
        const { renderPage } = this.state;
        if (!renderPage) {
            return null;
        }

        return (
            <SomethingWentWrong
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SomethingWentWrongContainer);
